import { Typography } from "@mui/material";
import React from "react";
import { DocumentRef } from "src/models/documents";
import DocumentViewer from "src/reusable-components/DocumentViewer/DocumentViewer";
import { Container } from "./styles";

interface Props {
  receiptDocument: DocumentRef | null;
}
const TravelExpenseHints = ({ receiptDocument }: Props) => {
  return (
    <Container>
      {receiptDocument?.files[0] ? (
        <DocumentViewer
          fileDto={receiptDocument.files[0]}
          defaultMainScale={0.5}
          embedded
        />
      ) : (
        <Typography variant="h5">Do not forget to attach the receipt please</Typography>
      )}
    </Container>
  );
};
export default TravelExpenseHints;
